// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1249":"58c75a6d0f7e9c0d","6066":"5d239a6602992371","6698":"2a2d2c2a962cecb2"}[chunkId] + ".js";
};